// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../common.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27%2364748b%27%3E%3Cpath d=%27M7 10l5 5 5-5z%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Configuration page — extends shared admin (Users / Roles) theme */

.admin-config-content {
  max-width: 760px;
}

.admin-config-form {
  margin-top: 8px;
}

.admin-config-sections {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.admin-config-section {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  overflow: hidden;
}

.admin-config-section-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 18px;
  background: #f8fafc;
  border: none;
  border-bottom: 1px solid transparent;
  cursor: pointer;
  text-align: left;
  transition: background 0.15s ease;
}

.admin-config-section-header:hover {
  background: #f1f5f9;
}

.admin-config-section-header[aria-expanded="true"] {
  border-bottom-color: #e2e8f0;
}

.admin-config-section-title {
  font-size: 14px;
  font-weight: 700;
  color: #2563eb;
  letter-spacing: 0.02em;
}

.admin-config-chevron {
  color: #64748b;
  flex-shrink: 0;
}

.admin-config-section-body {
  padding: 20px 20px 8px;
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.admin-config-section-header-static {
  cursor: default;
}

.admin-config-section-header-static:hover {
  background: #f8fafc;
}

.admin-config-section-hint {
  margin: 0 0 16px;
  font-size: 13px;
  color: #64748b;
  line-height: 1.45;
}

.admin-config-subgroup {
  margin-bottom: 8px;
}

.admin-config-subgroup-header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  padding: 0 0 10px;
  margin-bottom: 8px;
  background: none;
  border: none;
  border-bottom: 1px solid #e2e8f0;
  cursor: pointer;
  font-size: 13px;
  font-weight: 600;
  color: #475569;
  text-align: left;
}

.admin-config-tg-row {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 16px;
  margin-bottom: 4px;
}

.admin-config-footer-inline {
  margin-top: 8px;
  padding-top: 16px;
  justify-content: flex-start;
}

.admin-config-field {
  margin-bottom: 18px;
}

.admin-config-field:last-child {
  margin-bottom: 12px;
}

.admin-field-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 8px;
}

.admin-config-required {
  color: #dc2626;
  font-weight: 600;
}

.admin-config-format-hint {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-top: 6px;
  font-size: 12px;
  color: #64748b;
}

.admin-input.admin-select {
  cursor: pointer;
  appearance: none;
  background-color: #fff;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 12px center;
  padding-right: 36px;
}

.admin-password-wrap {
  position: relative;
  display: flex;
  align-items: center;
}

.admin-password-wrap .admin-input {
  padding-right: 44px;
}

.admin-password-toggle {
  position: absolute;
  right: 12px;
  background: none;
  border: none;
  color: #64748b;
  cursor: pointer;
  padding: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.admin-password-toggle:hover {
  color: #1a202c;
}

.admin-config-footer {
  margin-top: 28px;
  padding-top: 24px;
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
}

.admin-config-save {
  min-width: 180px;
  padding: 10px 24px;
  font-size: 14px;
}

.admin-config-empty {
  color: #94a3b8;
  font-style: italic;
  text-align: center;
  padding: 32px 16px;
}

@media (max-width: 768px) {
  .admin-config-content {
    max-width: 100%;
  }

  .admin-config-footer {
    justify-content: stretch;
  }

  .admin-config-save {
    width: 100%;
  }

  .admin-config-tg-row {
    grid-template-columns: 1fr;
    gap: 0;
  }
}

/* ===== Dark theme overrides (light mode untouched) ===== */
[data-theme="dark"] .admin-config-section {
  border-color: var(--border);
  background: var(--surface-2);
}
[data-theme="dark"] .admin-config-section-header {
  background: var(--surface-3);
}
[data-theme="dark"] .admin-config-section-header:hover {
  background: var(--surface-hover);
}
[data-theme="dark"] .admin-config-section-header[aria-expanded="true"] {
  border-bottom-color: var(--border);
}
[data-theme="dark"] .admin-field-label {
  color: var(--text);
}
[data-theme="dark"] .admin-config-section-hint,
[data-theme="dark"] .admin-config-subgroup-header {
  color: var(--text-muted);
}
[data-theme="dark"] .admin-config-section-header-static:hover {
  background: var(--surface-3);
}
[data-theme="dark"] .admin-config-subgroup-header {
  border-bottom-color: var(--border);
}
[data-theme="dark"] .admin-config-format-hint,
[data-theme="dark"] .admin-config-chevron,
[data-theme="dark"] .admin-password-toggle {
  color: var(--text-muted);
}
[data-theme="dark"] .admin-password-toggle:hover {
  color: var(--text);
}
[data-theme="dark"] .admin-input.admin-select {
  background-color: var(--surface);
}
.tg-config-section {
  margin-top: 2rem;
}

.tg-config-section-sub {
  margin-top: 1rem;
}

.tg-config-section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
  margin-bottom: 12px;
}

.tg-config-section-title {
  margin: 0;
  font-size: 1.125rem;
  font-weight: 600;
  color: #0f172a;
}

.tg-config-section-subtitle {
  margin: 0;
  font-size: 0.9375rem;
  font-weight: 600;
  color: #334155;
}

/* ── Interval radio group ── */
.tg-interval-radio-wrap {
  display: flex;
  align-items: center;
  gap: 16px;
  flex-wrap: wrap;
}

.tg-radio-group {
  display: flex;
  gap: 10px;
}

.tg-radio-option {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 7px 18px;
  border: 1.5px solid #cbd5e1;
  border-radius: 8px;
  cursor: pointer;
  font-size: 0.875rem;
  font-weight: 500;
  color: #475569;
  background: #fff;
  transition: border-color 0.15s, background 0.15s, color 0.15s;
  -webkit-user-select: none;
          user-select: none;
}

.tg-radio-option:hover {
  border-color: #2563eb;
  color: #2563eb;
}

.tg-radio-option-active {
  border-color: #2563eb;
  background: #eff6ff;
  color: #2563eb;
}

.tg-radio-input {
  accent-color: #2563eb;
  width: 15px;
  height: 15px;
  cursor: pointer;
}

/* ── Option blocks ── */
.tg-option-block {
  margin-top: 2rem;
  padding: 20px 24px;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  background: #fff;
}

.tg-option-block-header {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-bottom: 16px;
  padding-bottom: 14px;
  border-bottom: 1px solid #e2e8f0;
}

.tg-option-block-label {
  font-size: 1rem;
  font-weight: 700;
  color: #0f172a;
}

.tg-option-block-badge {
  font-size: 0.75rem;
  font-weight: 600;
  color: #2563eb;
  background: #eff6ff;
  border: 1px solid #bfdbfe;
  border-radius: 20px;
  padding: 2px 10px;
  letter-spacing: 0.02em;
}

[data-theme="dark"] .tg-radio-option {
  border-color: var(--border);
  background: var(--surface);
  color: var(--text-muted);
}
[data-theme="dark"] .tg-radio-option:hover {
  border-color: #3b82f6;
  color: #60a5fa;
}
[data-theme="dark"] .tg-radio-option-active {
  border-color: #3b82f6;
  background: rgba(37, 99, 235, 0.12);
  color: #60a5fa;
}
[data-theme="dark"] .tg-option-block {
  border-color: var(--border);
  background: var(--surface-2);
}
[data-theme="dark"] .tg-option-block-header {
  border-bottom-color: var(--border);
}
[data-theme="dark"] .tg-option-block-label {
  color: var(--text);
}
[data-theme="dark"] .tg-option-block-badge {
  background: rgba(37, 99, 235, 0.15);
  border-color: rgba(59, 130, 246, 0.3);
  color: #60a5fa;
}

.tg-config-section-toolbar {
  margin: 0;
}

.tg-id-list-fields {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.tg-id-list-row {
  display: flex;
  align-items: flex-start;
  gap: 12px;
}

.tg-id-list-item {
  flex: 1 1;
  margin-bottom: 8px;
}

.tg-id-list-remove {
  margin-top: 30px;
  white-space: nowrap;
}

.tg-id-list-add {
  margin-top: 4px;
  margin-bottom: 8px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/Configuration/index.css"],"names":[],"mappings":"AAEA,oEAAoE;;AAEpE;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,oCAAoC;EACpC,eAAe;EACf,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,gCAAgC;EAChC,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yDAA4L;EAC5L,4BAA4B;EAC5B,sCAAsC;EACtC,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,eAAe;EACf,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;IAC1B,MAAM;EACR;AACF;;AAEA,4DAA4D;AAC5D;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kBAAkB;AACpB;AACA;;EAEE,wBAAwB;AAC1B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,kCAAkC;AACpC;AACA;;;EAGE,wBAAwB;AAC1B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,2BAA2B;EAC3B,kBAAkB;EAClB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,6DAA6D;EAC7D,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA,wBAAwB;AACxB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,wBAAwB;AAC1B;AACA;EACE,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,mCAAmC;EACnC,cAAc;AAChB;AACA;EACE,2BAA2B;EAC3B,4BAA4B;AAC9B;AACA;EACE,kCAAkC;AACpC;AACA;EACE,kBAAkB;AACpB;AACA;EACE,mCAAmC;EACnC,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,SAAO;EACP,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;AACpB","sourcesContent":["@import \"../common.css\";\n\n/* Configuration page — extends shared admin (Users / Roles) theme */\n\n.admin-config-content {\n  max-width: 760px;\n}\n\n.admin-config-form {\n  margin-top: 8px;\n}\n\n.admin-config-sections {\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.admin-config-section {\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #fff;\n  overflow: hidden;\n}\n\n.admin-config-section-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 18px;\n  background: #f8fafc;\n  border: none;\n  border-bottom: 1px solid transparent;\n  cursor: pointer;\n  text-align: left;\n  transition: background 0.15s ease;\n}\n\n.admin-config-section-header:hover {\n  background: #f1f5f9;\n}\n\n.admin-config-section-header[aria-expanded=\"true\"] {\n  border-bottom-color: #e2e8f0;\n}\n\n.admin-config-section-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #2563eb;\n  letter-spacing: 0.02em;\n}\n\n.admin-config-chevron {\n  color: #64748b;\n  flex-shrink: 0;\n}\n\n.admin-config-section-body {\n  padding: 20px 20px 8px;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.admin-config-section-header-static {\n  cursor: default;\n}\n\n.admin-config-section-header-static:hover {\n  background: #f8fafc;\n}\n\n.admin-config-section-hint {\n  margin: 0 0 16px;\n  font-size: 13px;\n  color: #64748b;\n  line-height: 1.45;\n}\n\n.admin-config-subgroup {\n  margin-bottom: 8px;\n}\n\n.admin-config-subgroup-header {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  padding: 0 0 10px;\n  margin-bottom: 8px;\n  background: none;\n  border: none;\n  border-bottom: 1px solid #e2e8f0;\n  cursor: pointer;\n  font-size: 13px;\n  font-weight: 600;\n  color: #475569;\n  text-align: left;\n}\n\n.admin-config-tg-row {\n  display: grid;\n  grid-template-columns: 140px 1fr;\n  gap: 16px;\n  margin-bottom: 4px;\n}\n\n.admin-config-footer-inline {\n  margin-top: 8px;\n  padding-top: 16px;\n  justify-content: flex-start;\n}\n\n.admin-config-field {\n  margin-bottom: 18px;\n}\n\n.admin-config-field:last-child {\n  margin-bottom: 12px;\n}\n\n.admin-field-label {\n  display: block;\n  font-size: 13px;\n  font-weight: 600;\n  color: #374151;\n  margin-bottom: 8px;\n}\n\n.admin-config-required {\n  color: #dc2626;\n  font-weight: 600;\n}\n\n.admin-config-format-hint {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  margin-top: 6px;\n  font-size: 12px;\n  color: #64748b;\n}\n\n.admin-input.admin-select {\n  cursor: pointer;\n  appearance: none;\n  background-color: #fff;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='%2364748b'%3E%3Cpath d='M7 10l5 5 5-5z'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  padding-right: 36px;\n}\n\n.admin-password-wrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n}\n\n.admin-password-wrap .admin-input {\n  padding-right: 44px;\n}\n\n.admin-password-toggle {\n  position: absolute;\n  right: 12px;\n  background: none;\n  border: none;\n  color: #64748b;\n  cursor: pointer;\n  padding: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.admin-password-toggle:hover {\n  color: #1a202c;\n}\n\n.admin-config-footer {\n  margin-top: 28px;\n  padding-top: 24px;\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.admin-config-save {\n  min-width: 180px;\n  padding: 10px 24px;\n  font-size: 14px;\n}\n\n.admin-config-empty {\n  color: #94a3b8;\n  font-style: italic;\n  text-align: center;\n  padding: 32px 16px;\n}\n\n@media (max-width: 768px) {\n  .admin-config-content {\n    max-width: 100%;\n  }\n\n  .admin-config-footer {\n    justify-content: stretch;\n  }\n\n  .admin-config-save {\n    width: 100%;\n  }\n\n  .admin-config-tg-row {\n    grid-template-columns: 1fr;\n    gap: 0;\n  }\n}\n\n/* ===== Dark theme overrides (light mode untouched) ===== */\n[data-theme=\"dark\"] .admin-config-section {\n  border-color: var(--border);\n  background: var(--surface-2);\n}\n[data-theme=\"dark\"] .admin-config-section-header {\n  background: var(--surface-3);\n}\n[data-theme=\"dark\"] .admin-config-section-header:hover {\n  background: var(--surface-hover);\n}\n[data-theme=\"dark\"] .admin-config-section-header[aria-expanded=\"true\"] {\n  border-bottom-color: var(--border);\n}\n[data-theme=\"dark\"] .admin-field-label {\n  color: var(--text);\n}\n[data-theme=\"dark\"] .admin-config-section-hint,\n[data-theme=\"dark\"] .admin-config-subgroup-header {\n  color: var(--text-muted);\n}\n[data-theme=\"dark\"] .admin-config-section-header-static:hover {\n  background: var(--surface-3);\n}\n[data-theme=\"dark\"] .admin-config-subgroup-header {\n  border-bottom-color: var(--border);\n}\n[data-theme=\"dark\"] .admin-config-format-hint,\n[data-theme=\"dark\"] .admin-config-chevron,\n[data-theme=\"dark\"] .admin-password-toggle {\n  color: var(--text-muted);\n}\n[data-theme=\"dark\"] .admin-password-toggle:hover {\n  color: var(--text);\n}\n[data-theme=\"dark\"] .admin-input.admin-select {\n  background-color: var(--surface);\n}\n.tg-config-section {\n  margin-top: 2rem;\n}\n\n.tg-config-section-sub {\n  margin-top: 1rem;\n}\n\n.tg-config-section-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  flex-wrap: wrap;\n  margin-bottom: 12px;\n}\n\n.tg-config-section-title {\n  margin: 0;\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #0f172a;\n}\n\n.tg-config-section-subtitle {\n  margin: 0;\n  font-size: 0.9375rem;\n  font-weight: 600;\n  color: #334155;\n}\n\n/* ── Interval radio group ── */\n.tg-interval-radio-wrap {\n  display: flex;\n  align-items: center;\n  gap: 16px;\n  flex-wrap: wrap;\n}\n\n.tg-radio-group {\n  display: flex;\n  gap: 10px;\n}\n\n.tg-radio-option {\n  display: flex;\n  align-items: center;\n  gap: 7px;\n  padding: 7px 18px;\n  border: 1.5px solid #cbd5e1;\n  border-radius: 8px;\n  cursor: pointer;\n  font-size: 0.875rem;\n  font-weight: 500;\n  color: #475569;\n  background: #fff;\n  transition: border-color 0.15s, background 0.15s, color 0.15s;\n  user-select: none;\n}\n\n.tg-radio-option:hover {\n  border-color: #2563eb;\n  color: #2563eb;\n}\n\n.tg-radio-option-active {\n  border-color: #2563eb;\n  background: #eff6ff;\n  color: #2563eb;\n}\n\n.tg-radio-input {\n  accent-color: #2563eb;\n  width: 15px;\n  height: 15px;\n  cursor: pointer;\n}\n\n/* ── Option blocks ── */\n.tg-option-block {\n  margin-top: 2rem;\n  padding: 20px 24px;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  background: #fff;\n}\n\n.tg-option-block-header {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  margin-bottom: 16px;\n  padding-bottom: 14px;\n  border-bottom: 1px solid #e2e8f0;\n}\n\n.tg-option-block-label {\n  font-size: 1rem;\n  font-weight: 700;\n  color: #0f172a;\n}\n\n.tg-option-block-badge {\n  font-size: 0.75rem;\n  font-weight: 600;\n  color: #2563eb;\n  background: #eff6ff;\n  border: 1px solid #bfdbfe;\n  border-radius: 20px;\n  padding: 2px 10px;\n  letter-spacing: 0.02em;\n}\n\n[data-theme=\"dark\"] .tg-radio-option {\n  border-color: var(--border);\n  background: var(--surface);\n  color: var(--text-muted);\n}\n[data-theme=\"dark\"] .tg-radio-option:hover {\n  border-color: #3b82f6;\n  color: #60a5fa;\n}\n[data-theme=\"dark\"] .tg-radio-option-active {\n  border-color: #3b82f6;\n  background: rgba(37, 99, 235, 0.12);\n  color: #60a5fa;\n}\n[data-theme=\"dark\"] .tg-option-block {\n  border-color: var(--border);\n  background: var(--surface-2);\n}\n[data-theme=\"dark\"] .tg-option-block-header {\n  border-bottom-color: var(--border);\n}\n[data-theme=\"dark\"] .tg-option-block-label {\n  color: var(--text);\n}\n[data-theme=\"dark\"] .tg-option-block-badge {\n  background: rgba(37, 99, 235, 0.15);\n  border-color: rgba(59, 130, 246, 0.3);\n  color: #60a5fa;\n}\n\n.tg-config-section-toolbar {\n  margin: 0;\n}\n\n.tg-id-list-fields {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.tg-id-list-row {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n}\n\n.tg-id-list-item {\n  flex: 1;\n  margin-bottom: 8px;\n}\n\n.tg-id-list-remove {\n  margin-top: 30px;\n  white-space: nowrap;\n}\n\n.tg-id-list-add {\n  margin-top: 4px;\n  margin-bottom: 8px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
